export class Locale {
    [x: string]: any;
    id: number;
    name: string;
    description: string;
    language: string;
    country: string;
    decChar: string;
    amtConversion: string;
    dateConversion: string;
}